/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { withTranslation } from 'react-i18next';
import validFile from '@constants/validFile';
import FailConnection from '../Forms/FailConnection';
import classes from './Dropzone.module.scss';
import FileList from './FileList';
import Drop from './Drop';
import Success from './Success';
import Progress from './Progress';
import ShowDocumentError from './ShowDocumentError';

const Dropzone = ({
  filesLimit,
  disabled,
  handleFilesUploaded: handleFilesUploadedProp,
  t,
  className,
  connectionError,
  success,
  uploading,
  delay,
  tagAdd,
  idSubir,
  onSubirClick,
  tagUpload,
}) => {
  const { documents } = useSelector((state) => state.onboarding);
  const [dropzone, setDropzone] = useState({
    fileList: documents?.userFiles,
    errFileList: [],
    filesLimit: 0,
    showError: false,
  });

  useEffect(() => {
    setDropzone((state) => ({
      ...state,
      filesLimit: filesLimit || documents?.quantity,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documents?.quantity, filesLimit]);

  const fileInputRef = useRef();

  const openFileDialog = () => {
    if (disabled) return;
    fileInputRef.current.click();
  };

  const onCloseError = () => setDropzone((state) => ({ ...state, showError: false }));

  const handleDelete = (e, { file }) => {
    const filterList = (elm) => (elm !== file ? elm : null);
    const fileList = dropzone.fileList.filter(filterList);
    const errFileList = dropzone.errFileList.filter(filterList);

    setDropzone((state) => ({ ...state, fileList, errFileList }));
    handleFilesUploadedProp(fileList);
  };

  const getResultOnAddFiles = (files) => {
    const fileList = [];
    const errFileList = [];
    Array.from(files).forEach((file) => {
      const validationObject = validFile(file, dropzone.fileList);
      if (validationObject.succes) {
        fileList.push(file);
      } else {
        errFileList.push({ name: file.name, ...validationObject });
      }
    });
    return { fileList: fileList.concat(dropzone.fileList), errFileList };
  };

  const isQtyValid = (totalFilesLength) => totalFilesLength <= dropzone.filesLimit;

  const handleFilesUploaded = (files) => {
    setDropzone((state) => ({ ...state, showError: false }));
    const totalFilesLength = files.length + dropzone.fileList.length;
    if (isQtyValid(totalFilesLength)) {
      const { fileList, errFileList } = getResultOnAddFiles(files);
      setDropzone((state) => ({ ...state, fileList, errFileList }));
      handleFilesUploadedProp(fileList);
    } else {
      setDropzone((state) => ({ ...state, showError: true }));
    }
  };

  const onFilesAdded = (evt) => {
    const { files } = evt.target;
    handleFilesUploaded(files);
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  const onDrop = (event) => {
    event.preventDefault();
    const { files } = event.dataTransfer;
    handleFilesUploaded(files);
  };

  const { fileList, errFileList } = dropzone;

  return (
    <div
      className={[classes.dropzonContainer, className].join(' ')}
      style={{ overflow: 'hidden' }}
      onDragOver={onDragOver}
      id="dropzone-container"
    >
      {connectionError ? (
        <FailConnection />
      ) : success ? (
        <Success />
      ) : uploading ? (
        <Progress />
      ) : dropzone.showError ? (
        <ShowDocumentError closeError={onCloseError} cant={dropzone.filesLimit} />
      ) : (
        <>
          <Drop
            onDragOver={onDragOver}
            onDrop={onDrop}
            openFileDialog={openFileDialog}
            disabled={disabled}
            fileInputRef={fileInputRef}
            onFilesAdded={onFilesAdded}
            delay={delay}
            tagAdd={tagAdd}
            idSubir={idSubir || ''}
          />
          {(fileList.length > 0 || errFileList.length > 0) && (
            <FileList
              fileList={fileList}
              errFileList={errFileList}
              onDragOver={onDragOver}
              delay={delay}
              idSubir={idSubir}
              onSubirClick={onSubirClick}
              handleDelete={handleDelete}
              uploadButtonText={t('documentation.addFiles.buttonUpload')}
              tagUpload={tagUpload}
            />
          )}
        </>
      )}
    </div>
  );
};

export default withTranslation()(Dropzone);
